import classNames from 'classnames'
import { Icon } from '@winnin/winnin_ui.components.icon'

import BreadCrumb from 'components/BreadCrumb'
import { useIsMobileDevice } from 'hooks'

import './index.scss'

const BreadCrumbs = ({ breadcrumbs }) => {
  const isMobileDevice = useIsMobileDevice()

  const lastItem = [...breadcrumbs].at(-2)
  const currentItem = [...breadcrumbs].at(-1)

  return (
    <div className="BreadCrumbs">
      {isMobileDevice ? (
        <>
          <BreadCrumb
            handleOnClick={lastItem?.handleClick}
            link={lastItem?.link}
            title={<Icon icon="arrowLeft" fill="var(--gray)" />}
            key={lastItem?.link}
            isClickBlocked={lastItem?.isClickBlocked}
            hideArrow
          />
          <BreadCrumb
            className="BreadCrumbs-customBreadCrumb"
            handleOnClick={currentItem?.handleClick}
            link={currentItem?.link}
            title={currentItem?.title}
            key={currentItem?.link}
            isClickBlocked
            hideArrow
          />
        </>
      ) : (
        <>
          {breadcrumbs?.map((item, index) => {
            const isLastLevel = item?.isLastLevel || index + 1 === breadcrumbs?.length
            const key = item?.link ? `${item?.link}-${item?.title}` : `${index}-${item?.title}`

            return (
              <BreadCrumb
                handleOnClick={item?.handleClick}
                link={item?.link}
                title={item?.title}
                isLastLevel={isLastLevel}
                key={key}
                isClickBlocked={item?.isClickBlocked}
                hideArrow={isLastLevel}
                className={classNames({
                  'BreadCrumbs-customBreadCrumb': isLastLevel || item?.isClickBlocked,
                })}
              />
            )
          })}
        </>
      )}
    </div>
  )
}

export default BreadCrumbs
